import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_USER_TERM_AND_CONDITION_LIST,
    getUserTermAndConditionListFail,
    getUserTermAndConditionListSuccess
} from '../action/getUserTermAndConditionListAction'

// api 
import getUserTermAndConditionListApi from '../api/getUserTermAndConditionListApi'

export function* getUserTermAndConditionListSaga(action) {
    try {
        const response = yield call(() => getUserTermAndConditionListApi(action.params))
        if (response.data.status === 1) {
            yield put(getUserTermAndConditionListSuccess(response, action))
        } else {
            yield put(getUserTermAndConditionListFail(response, action))
        }
    }
    catch (e) {
        yield put(getUserTermAndConditionListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_USER_TERM_AND_CONDITION_LIST, getUserTermAndConditionListSaga)
}